// extracted by mini-css-extract-plugin
export default {"NavBar":"DesktopNavBar_NavBar__bksEV","NavBarContainer":"DesktopNavBar_NavBarContainer__1egLF","Emoji":"DesktopNavBar_Emoji__kGNO5","NavBarItems":"DesktopNavBar_NavBarItems__tBFrS"};